import React, { useEffect, useState } from "react";
import { LayoutGrid, List } from "lucide-react";
import { useSearchParams } from "next/navigation";

export default function ViewToggle({ translations }: { translations: any }) {
  const searchParams = useSearchParams();
  const listViewQueryParam = searchParams.get("view");
  const [isListView, setIsListView] = useState(listViewQueryParam === "list");

  useEffect(() => {
    const viewParam = searchParams.get("view");
    setIsListView(viewParam === "list");
  }, [searchParams]);

  const handleViewToggle = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const newIsListView = !isListView;

    if (newIsListView) {
      searchParams.set("view", "list");
    } else {
      searchParams.delete("view");
    }

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", decodeURIComponent(newUrl));
    setIsListView(newIsListView);
  };

  return (
    <>
      <button
        onClick={handleViewToggle}
        className={`xs:ml-0 mr-2.5 whitespace-nowrap rounded-md border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] px-4 py-[7px] text-sm font-medium text-white hover:brightness-105 focus:outline-none focus:ring-0 focus:ring-gray-300`}
      >
        {isListView ? <List className="h-5 w-5" /> : <LayoutGrid className="h-5 w-5" />}
      </button>
    </>
  );
}
